var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("GChart", {
    ref: "gChart",
    attrs: {
      settings: { packages: ["corechart"] },
      type: "PieChart",
      data: _vm.pieChartdata,
      options: _vm.dynamicOptions,
      events: _vm.chartEvents
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }